import { render, staticRenderFns } from "./work-order-attachments.html?vue&type=template&id=70eea407&scoped=true&"
import script from "./work-order-attachments.js?vue&type=script&lang=js&"
export * from "./work-order-attachments.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eea407",
  null
  
)

export default component.exports